/**
 * Imię pieska — sugestie + fallback generatora (PLAN §10.1).
 * Moderacja z @pieskowo/shared (zamrożona).
 */
import {
  DOGS,
  type DogBreedId,
  generateName,
  nameModerator,
} from '@pieskowo/shared';

/** Stałe sugestie z fabuły + trzecia z generatora. */
export function nameSuggestions(breed: DogBreedId, seed?: number): [string, string, string] {
  const breedDefault = DOGS[breed]?.defaultName ?? 'Misia';
  const third = generateName(seed);
  // Misia, Lola + losowa (unikaj duplikatów)
  const fixed = ['Misia', 'Lola'] as const;
  let extra = third;
  if (extra === fixed[0] || extra === fixed[1] || extra === breedDefault) {
    extra = generateName((seed ?? 1) + 97);
  }
  if (extra === fixed[0] || extra === fixed[1]) {
    extra = breedDefault === fixed[0] || breedDefault === fixed[1] ? 'Bella' : breedDefault;
  }
  return [fixed[0], fixed[1], extra];
}

/**
 * Rozstrzyga imię: puste → generator; nieprzechodzi moderacji → suggestion z walidatora.
 */
export function resolveDogName(raw: string, seed?: number): {
  dogName: string;
  usedFallback: boolean;
  moderationOk: boolean;
} {
  const trimmed = raw.trim();
  if (!trimmed) {
    return {
      dogName: generateName(seed),
      usedFallback: true,
      moderationOk: true,
    };
  }
  const mod = nameModerator.validate(trimmed);
  if (mod.ok) {
    return { dogName: mod.normalized, usedFallback: false, moderationOk: true };
  }
  return {
    dogName: mod.suggestion,
    usedFallback: true,
    moderationOk: false,
  };
}
